import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FaqBlock = ({ heading = true, max = 8 }) => (
  <section id="faq" className="bg-[#FFFCFA] py-24 md:py-32" data-testid="faq-block">
    <div className="mx-auto max-w-5xl px-6 md:px-12">
      {heading && (
        <div className="mb-12 text-center">
          <p className="text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-[#FBC4A8]">Glow With Confidence</p>
          <h2 className="mt-4 font-display text-4xl font-normal leading-[1.05] tracking-tight text-[#2C2B2C] md:text-5xl">
            Everything you need to <span className="text-[#E97C6A]">know.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base font-light leading-relaxed text-[#8A7F86]">
            Still curious about your Aura Glow ritual? Here are the answers our community asks most.
          </p>
        </div>
      )}

      <Accordion type="single" collapsible className="grid w-full gap-3.5 md:grid-cols-2 md:items-start" data-testid="faq-accordion">
        {FAQS.slice(0, max).map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`}
            className="overflow-hidden rounded-2xl border border-[#F2E8E6] bg-white px-6 transition-all duration-300 data-[state=open]:border-[#F4A98A]/70 data-[state=open]:bg-[#FFF6EF] data-[state=open]:shadow-[0_22px_50px_-32px_rgba(120,80,55,0.45)]">
            <AccordionTrigger data-testid={`faq-trigger-${i}`}
              className="py-5 text-left font-display text-lg text-[#2C2B2C] hover:no-underline [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#FBC4A8]">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-base font-light leading-relaxed text-[#7A6E73]">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-12 flex flex-col items-center justify-center gap-4 rounded-2xl border border-[#F2E8E6] bg-white px-6 py-7 text-center sm:flex-row sm:gap-6 sm:text-left">
        <p className="text-sm font-light text-[#6E6168]">Still have a question? Our Gold Coast team is happy to help.</p>
        <Link to="/contact" data-testid="faq-contact-link"
          className="inline-flex flex-none items-center gap-1.5 rounded-full bg-[#2C2B2C] px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-[#FBC4A8]">
          Talk to our team <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);
